export default {
    'searchList': {
        'searchTxt': [
            {
                'name': '分公司',
                'value': 'companyName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'companyNameCn', 'value': '分公司名称' },
                    { 'prop': 'companyCode', 'value': '分公司编码' }
                ],
                'tableConfig': [
                    { 'prop': 'companyNameCn', 'value': '分公司名称' },
                    { 'prop': 'companyCode', 'value': '分公司编码' }
                ],
                'advanceUrl': '/esCompany/popCompany',
                'type': 'advance',
                'cbParams': ['companyCode#companyCode', 'companyNameCn#companyName'],
                'span': 3
            },
            {
                'name': '服务平台',
                'value': 'siteName',
                'unfold': true,
                'advanceConfig': [
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
                ],
                'tableConfig': [
                    { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                    { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
                ],
                'advanceUrl': '/searchPlatform',
                'type': 'advance',
                'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                'span': 3
            },
            {
                'name': '押金单号',
                'value': 'supCashNo',
                'type': 'input',
                'unfold': true,
                'span': 3,
                'data': ''
            },
            {
                'name': '合同编号',
                'value': 'mdcoContractNo',
                'type': 'input',
                'unfold': true,
                'span': 3
            },
            {
                'name': '状态',
                'value': 'statues',
                'type': 'select',
                'unfold': true,
                'span': 4,
                'filterable': true,
                'multiple': true,
                'data': ['20', '30'],
                'optionNum': 'SRM_BMS_SUP_DEPOSIT_STATUS'
            }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'searchTotalTitle': [
        {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeBegin',
            'endTime': 'createTimeEnd',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': true,
            'span': 6
        }
    ],
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'fixedSeletionColumn': true,
        'columns': [
            {
                'label': '押金单号',
                'prop': 'supCashNo',
                'width': '148px'
            },
            {
                'label': '合同编号',
                'prop': 'mdcoContractNo',
                'width': '160px'
            },
            {
                'label': '合同状态',
                'prop': 'statusText',
                'width': '100px'
            },
            {
                'label': '业务类型',
                'prop': 'businessProperty',
                'width': '86px'
            },
            {
                'label': '主体',
                'prop': 'ledgerName',
                'width': '260px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'width': '120px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'width': '120px'
            },
            {
                'label': '币种',
                'prop': 'currencyCode',
                'width': '70px'
            },
            {
                'label': '押金金额',
                'prop': 'budgetAmt',
                'width': '102px'
            },
            {
                'label': '现汇金额',
                'prop': 'toAmt',
                'width': '82px'
            },
            {
                'label': '应收转押金金额',
                'prop': 'payChangeCashAmt',
                'width': '120px'
            },
            {
                'label': '罚扣款金额',
                'prop': 'penaltyAmt',
                'width': '86px'
            },
            {
                'label': '计划退款',
                'prop': 'theReturnAmt',
                'width': '88px'
            },
            {
                'label': '实际退款',
                'prop': 'actualRefund',
                'width': '86px'
            },
            {
                'label': '余额',
                'prop': 'balanceAmt',
                'width': '70px'
            },
            {
                'label': '单据状态',
                'prop': 'status',
                'width': '102px'
            },
            {
                'label': '备注',
                'prop': 'remark',
                'width': '160px'
            }],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
        // 'pageSizes': [10, 20, 30, 50, 100]
    }
};
